import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Access from "../pages/access/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/access",
    element: <Access />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
